import Skins from "@/commons/resources/images/minecraft/defaults/skins";
import {isMinecraft} from "./Account";
import {calcCharsMax} from "./Utility";
import Cookies from "js-cookie";
import {environment} from '@/commons/configs/Config';

export function getMcHead(mcUID) {
    return "https://mc-heads.net/avatar/" + mcUID + ".png";
}

export function getMcSkin(mcUID) {
    return "https://mc-heads.net/body/" + mcUID + "/left/.png";
}

export function isBedrockUID(mcUID) {
    return mcUID.startsWith("00000000-");
}
export async function getUserHead(mcUUID, username) {
    let skinVal = calcCharsMax(username, Skins["max"]);

    if (mcUUID !== "") {
        let bedrock = isBedrockUID(mcUUID);

        if (bedrock) {
            return Skins[skinVal];
        } else {
            return getMcHead(mcUUID);
        }
    } else {
        return Skins[skinVal];
    }
}
export async function getUserSkin(mcUUID, username) {
    let skinVal = calcCharsMax(username, Skins["max"]);

    if (mcUUID !== "") {
        let bedrock = isBedrockUID(mcUUID);

        if (bedrock) {
            return getMcSkin(mcUUID);
        } else {
            return getMcSkin(mcUUID);
        }
    } else {
        return Skins[skinVal];
    }
}